import { CanActivateFn, Router } from "@angular/router";
import { inject } from "@angular/core";
import { map, tap } from "rxjs/operators";

import { ProfileService } from "../api/profile.service";

export const ConfirmedAccountGuard: CanActivateFn = () => {
  const profileService = inject(ProfileService);
  const router = inject(Router);

  return profileService.getGeneral(true).pipe(
    map((response) => response.isEmailConfirmed && response.isPhoneConfirmed),
    tap((isConfirmed) => {
      if (!isConfirmed) {
        router.navigate(["/setup"]);
      }
    })
  );
};
